import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {
        LiveList: {
            apiPath: '/loader/live-list',
            properties: {
                name: {
                    type: 'string',
                    displayName: '直播间名称',
                },
                roomid: {
                    type: 'number.integer',
                    displayName: '直播间ID',
                },
                recommend: {
                    type: 'number.integer',
                    displayName: '首页推荐',
                },
                dateTimeRange: {
                    type: 'object.dateTimeRange',
                    displayName: '直播时间',
                },
                anchorName: {
                    type: 'string',
                    displayName: '主播昵称',
                },
                liveStatus: {
                    type: 'string.options.select',
                    displayName: '直播间状态',
                    options: [
                        {
                            id: '101',
                            name: '直播中',
                        },
                        {
                            id: '102',
                            name: '未开始',
                        },
                        {
                            id: '103',
                            name: '已结束',
                        },
                        {
                            id: '104',
                            name: '禁播',
                        },
                        {
                            id: '105',
                            name: '暂停中',
                        },
                        {
                            id: '106',
                            name: '异常',
                        },
                        {
                            id: '107',
                            name: '已过期',
                        },
                    ],
                },
                liveCtrlPreview: {
                    type: 'string.options.select',
                    displayName: '是否展示预览',
                    options: [
                        {
                            id: '0',
                            name: '是',
                        },
                        {
                            id: '1',
                            name: '否',
                        },
                    ],
                },
            },
        },
        LiveBannerList: {
            apiPath: '/loader/live-list',
            properties: {
                id: {
                    type: 'number.integer',
                    displayName: '序号',
                },
                name: {
                    type: 'string',
                    displayName: '名称',
                },
                imgUrl: {
                    type: 'string.image.text',
                    displayName: '图片',
                },

                url: {
                    type: 'string',
                    displayName: '商品链接',
                },
                sort: {
                    type: 'string',
                    displayName: '顺序',
                    controlConfig: {
                        placeholder: '顺序',
                    },
                },
                status: {
                    type: 'string.options.select',
                    displayName: '是否显示',
                    options: [
                        {
                            id: 'DISPLAY',
                            name: '是',
                        },
                        {
                            id: 'HIDE',
                            name: '否',
                        },
                    ],
                },
            },
        },
    },
    components: {
        LivelistPage: {
            component: 'Viewport',
        },
        LiveRoomsList: {
            component: 'liveRoomTabComponent',
        },
        liveRoomTabComponent: {
            entity: 'LiveList',
            component: 'Card',
            content: {
                component: 'Tabs',

                items: [
                    {
                        title: 'banner管理',
                        content: {
                            component: 'liveBanner',
                        },
                    },
                ],
            },
        },
        liveBanner: {
            entity: 'LiveBannerList',
            component: 'liveBannerList',
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/live-list',
                    breadcrumbName: '直播管理',
                    component: 'LivelistPage',
                    childRoutes: [
                        {
                            path: '/',
                            breadcrumbName: '直播列表管理',
                            component: 'LiveRoomsList',
                        },
                    ],
                },
            ],
        },
    ],
};
